import React, { FC } from 'react'
import { ListSubheader, makeStyles, ListSubheaderProps, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { calcRem } from 'transfix-ui/theme/typography'

interface INavListSubheaderProps extends Omit<ListSubheaderProps, 'disableSticky'> {}

const useNavListSubheaderStyles = makeStyles(theme => ({
  root: {
    '&.MuiListSubheader-root': {
      paddingTop: 0,
      paddingLeft: 0,
      paddingBottom: theme.spacing(2),
      paddingRight: 0,
      lineHeight: calcRem(16),
      color: 'inherit',
    },
  },
  typography: {
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    color: brandColors.skyBlue1,
  },
}))

/**
 * Custom implementation of <ListSubHeader /> that's used in <NavListItem />
 */
export const NavListSubheader: FC<INavListSubheaderProps> = ({ children, ...props }) => {
  const classes = useNavListSubheaderStyles()
  return (
    <ListSubheader className={classes.root} disableSticky {...props}>
      <Typography variant='overline' component='div' className={classes.typography}>
        {children}
      </Typography>
    </ListSubheader>
  )
}

export default NavListSubheader
